import { trace, SpanStatusCode } from '@opentelemetry/api';

import { getWebAnalyticsModule } from './webAnalytics';

const sendOpenTelemetryEvent = (
  name: string,
  message: string,
  tenantId?: string,
  error = true,
  customAttributes = {}
) => {
  const webAnalytics = getWebAnalyticsModule();
  const visitUuid = webAnalytics?.getVisitUUIDCookieOrZeroed() || 'unknown';

  const visitorUuid = webAnalytics?.getConsentId() || 'unknown';

  const consent = webAnalytics?.getConsent() || 'unknown';

  const consentGroups = webAnalytics?.getGroupsId() || 'unknown';

  const span = trace
    .getTracer('hp-all-in-one-plan')
    .startSpan('hp-all-in-one-plan', {
      attributes: {
        'workflow.name': name,
        error,
        tenantId: tenantId || 'unknown',
        message,
        visitUuid,
        visitorUuid,
        consent,
        consentGroups,
        ...customAttributes,
      },
    });
  if (error) {
    span.setStatus({ code: SpanStatusCode.ERROR, message });
  }
  span.end();
};

export default sendOpenTelemetryEvent;
